module.exports = __webpack_public_path__ + "static/2-47273eb80169cc0fdaa6d411a7759d07.jpg";